import React from 'react';
import { ICalculatorHeaderProps } from './ICalculatorHeaderProps';

const CalculatorHeader: React.FC<ICalculatorHeaderProps> = ({ text }) => {

   return (
      <div className='header-container'>
         <h2 className='calculator-header'>{text}</h2>
      </div>
   );
};

export default CalculatorHeader;
